


















































import { Component, Vue, Prop } from "vue-property-decorator";
import PicPreview from "@/components/pic-preview.vue";
@Component({
  components: {
    PicPreview,
  },
})
export default class TongueShetubaogao extends Vue {
  @Prop()
  private r: any;
  @Prop()
  private origin: any;
  private tempUrl: any = "";
  private ifShowPreview: boolean = false;
  /**
   * @description 打开图片预览
   */
  private showPreview(src) {
    this.tempUrl = src;
    this.ifShowPreview = true;
  }
}
